// eslint-disable-next-line boundaries/no-unknown-files
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PAGE_ROUTE } from '@app/constants/page-route';
import { MsalAuthService } from '@app/services/msal-auth/msal-auth.service';

export const supplyChainUserRouteGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
) => {
    const msalAuthService = inject(MsalAuthService);
    const router = inject(Router);

    const allowedRoles = next.data['roles'] as string[];
    const serviceLines = next.data['serviceLines'] as string[];
    if (msalAuthService.isSupplyChainGranted(allowedRoles, serviceLines)) {
        return true;
    }
    return router.parseUrl(`${PAGE_ROUTE.Main}/${PAGE_ROUTE.Home}`);
};
